import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";
import Loader from "../../shared/Loader";

export type SelectOption = {
	key: string;
	value: string;
	text: string;
};

const SelectField = ({
	registeredName,
	label,
	isRequired,
	requiredText,
	emptyOption,
	options,
	disabled,
	isValidating,
	onChange,
}: {
	registeredName: string;
	label: string;
	isRequired: boolean;
	requiredText: string;
	emptyOption?: string;
	options: Array<SelectOption>;
	disabled?: boolean;
	isValidating?: boolean;
	onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}) => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	const { onChange: registerOnChange, ...registerProps } =
		register(registeredName);

	const disabledClass = disabled ? " bg-gray-200 border-gray-400" : "";
	const cssClass =
		"border border-black w-full py-3 px-2 placeholder:uppercase" +
		disabledClass;

	return (
		<div className="mb-3">
			<label
				className="ml-2 flex items-center gap-1 text-sm uppercase"
				htmlFor={`input-${registeredName}`}
			>
				{label}
				{isRequired && "*"}
				{isValidating && (
					<Loader colorCircle="#000" colorRotator="#ddd" size="w-3 h-3" />
				)}
			</label>
			{errors && (
				<p className="mb-1 ml-2 text-xs text-red-500">
					<ErrorMessage errors={errors} name={registeredName} />
				</p>
			)}
			<select
				{...registerProps}
				name={registeredName}
				id={`input-${registeredName}`}
				className={cssClass}
				disabled={disabled}
				required={isRequired}
				onChange={(event) => {
					registerOnChange(event);
					onChange?.(event);
				}}
			>
				<option key={0} value="">
					{emptyOption || "Select an option"}
				</option>
				{options.map((option: SelectOption) => (
					<option key={option.key} value={option.value}>
						{option.text}
					</option>
				))}
			</select>
		</div>
	);
};
export default SelectField;
